const loadInfoScroller = () => {
  let observer = new IntersectionObserver(function(entries, observer) {
    // using a callback to stop the observer from re-running initScroller every time the element comes into view
    entries.forEach(entry => entry.isIntersecting ? (initScroller(entry.target), observer.unobserve(entry.target)) : false);
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  });

  const infoScrollers = Array.from(document.querySelectorAll('.slo-info-scroller'));
  infoScrollers.forEach(scroller => observer.observe(scroller));

  const initScroller = scroller => {
    const infoSwitches = Array.from(scroller.querySelectorAll('.slo-info-scroller--switch'));
    const infoContents = Array.from(scroller.querySelectorAll('.slo-info-scroller--content'));

    const timeouts = [];
    const intervals = [];
    const toggle = infoSwitch => toggleContent(infoSwitch);
    const delayLoop = (fn, delay) => {
      return (el, i) => {
        timeouts.push(setTimeout(() => fn(el), i * delay));
      };
    };

    infoSwitches.forEach(delayLoop(toggle, 4500));
    intervals.push(setInterval(() => infoSwitches.forEach(delayLoop(toggle, 4500)), infoSwitches.length * 4500));

    infoSwitches.forEach(infoSwitch => {
      infoSwitch.addEventListener('click', () => {
        toggleContent(infoSwitch);
        timeouts.forEach(timeout => clearTimeout(timeout));
        intervals.forEach(interval => clearInterval(interval));
      });
    });

    const toggleContent = infoSwitch => {
      infoSwitches.forEach(_infoSwitch => _infoSwitch.classList.remove('active'));
      infoSwitch.classList.add('active');

      const activeContents = Array.from(scroller.querySelectorAll('.slo-info-scroller--content-' + infoSwitch.dataset.value));
      infoContents.forEach(infoContent => infoContent.classList.add('hidden'));
      activeContents.forEach(activeContent => activeContent.classList.remove('hidden'));
    };
  };
};

export default loadInfoScroller;
